export default __webpack_public_path__ + "static/media/objects-bg-mobile.00eb86aa.jpg";